import { ChevronRight, type LucideIcon } from "lucide-preact";

export type SettingsMenuItemProps = {
  icon: LucideIcon;
  title: string;
  description?: string;
  currentValue?: string;
  onClick: () => void;
  class?: string;
  testId?: string;
};

export const SettingsMenuItem = ({ icon: Icon, title, description, currentValue, onClick, class: className = "", testId }: SettingsMenuItemProps) => (
  <button
    type="button"
    onClick={onClick}
    class={`w-full flex items-center justify-between px-6 py-4 transition-colors hover:bg-gray-50 dark:hover:bg-neutral-700/50 ${className}`}
    data-test-click={testId}
  >
    <div class="flex items-center gap-4 flex-1">
      <Icon size={20} class="text-gray-700 dark:text-gray-300" />
      <div class="flex-1 text-left">
        <h3 class="text-sm font-medium text-gray-900 dark:text-white">{title}</h3>
        {description && <p class="text-xs text-gray-600 dark:text-gray-400 mt-0.5">{description}</p>}
        {currentValue && <p class="text-xs text-gray-500 dark:text-gray-500 mt-0.5">{currentValue}</p>}
      </div>
    </div>
    <ChevronRight size={20} class="text-gray-400 dark:text-gray-500" />
  </button>
);
